import React, { useState } from "react";
import styles from "./index.less";
import classNames from "classnames";
interface ImageToggleProps {
  defaultImage: string;
  hoverImage: string;
  className?: string;
  onClick?: () => void;
  text?: string;
}

const ImageToggle: React.FC<ImageToggleProps> = ({
  defaultImage,
  hoverImage,
  className,
  onClick,
  text,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  const currentImage = isHovered ? hoverImage : defaultImage;

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      className={classNames(styles["image-toggle"], className)}
    >
      <img src={currentImage} />
      {text && <span style={{ fontSize: 10, paddingRight: 5 }}>{text}</span>}
    </div>
  );
};

export default ImageToggle;
